import { Route } from '@angular/router';
import { routes as checkoutRoutes } from '@seatix/checkout-routing';

export const appRoutes: Route[] = [
  {
    path: 'login',
    loadComponent: () =>
      import('./checkout-login/checkout-login.component').then(
        (m) => m.CheckoutLoginComponent,
      ),
  },
  {
    path: '',
    title: 'Seatix | Checkout',
    children: checkoutRoutes,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
